import { render, staticRenderFns } from "./Falafel.vue?vue&type=template&id=005feb79&scoped=true&"
import script from "./Falafel.vue?vue&type=script&lang=js&"
export * from "./Falafel.vue?vue&type=script&lang=js&"
import style0 from "./Falafel.vue?vue&type=style&index=0&id=005feb79&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005feb79",
  null
  
)

export default component.exports